import { buildRoutePath } from '@/lib/route-title'

function normalizePathname(p: string): string {
  if (!p || p === '/') return '/'
  return p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p
}

/** Списки: вспомогательные параметры не разделяют вкладки (меню ведёт на «чистый» URL). */
const LIST_PATHS_WITH_AUX_QUERY = new Set(['/tickets', '/ai-tickets', '/bookmarks'])
const AUX_QUERY_KEYS = new Set(['page_size', 'sort_by', 'sort_order'])

function parseSearchString(search: string): URLSearchParams {
  const s = search.startsWith('?') ? search.slice(1) : search
  return new URLSearchParams(s || '')
}

function sortedSearchString(sp: URLSearchParams): string {
  const keys = [...new Set([...sp.keys()])].sort()
  const out = new URLSearchParams()
  for (const k of keys) {
    const vals = [...sp.getAll(k)].filter(Boolean).sort()
    for (const v of vals) out.append(k, v)
  }
  return out.toString()
}

function canonicalTabSearch(pathname: string, search: string): string {
  const path = normalizePathname(pathname)
  const sp = parseSearchString(search || '')
  if (LIST_PATHS_WITH_AUX_QUERY.has(path)) {
    const copy = new URLSearchParams(sp)
    for (const k of AUX_QUERY_KEYS) copy.delete(k)
    return sortedSearchString(copy)
  }
  return sortedSearchString(sp)
}

/** Один и тот же пункт меню / логический экран (без дублей из-за page_size и сортировки). */
export function sameWorkspaceDestination(
  tabPathname: string,
  tabSearch: string,
  destPathname: string,
  destSearch: string,
): boolean {
  if (normalizePathname(tabPathname) !== normalizePathname(destPathname)) return false
  return canonicalTabSearch(tabPathname, tabSearch) === canonicalTabSearch(destPathname, destSearch)
}

export function findTabForDestination<T extends { id: string; pathname: string; search: string }>(
  tabs: T[],
  destPathname: string,
  destSearch: string,
): T | undefined {
  const want = buildRoutePath(destPathname, destSearch)
  const exact = tabs.find((t) => buildRoutePath(t.pathname, t.search) === want)
  if (exact) return exact
  return tabs.find((t) => sameWorkspaceDestination(t.pathname, t.search, destPathname, destSearch))
}
